import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import packageInfo from '../package.json';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  enableProdMode();
  console.log('%c⧭ Version ', 'color: #00861b; font-size: 16px; font-weight: 600', packageInfo.version);
  console.log = () => {};
}

Sentry.init({
  dsn: 'https://5b7548864f65bcabcdd866d2040d8c81@o4508177132552192.ingest.de.sentry.io/4508642102345808',
 

  integrations: [
    Sentry.browserTracingIntegration(), // Enables automatic tracing for navigation & API calls
    // Sentry.replayIntegration(),
    // Sentry.browserProfilingIntegration(),
  ],

  // **Controls how many traces to capture**
  tracesSampleRate: 1.0, // 1.0 = 100% of traces (for testing), reduce in production

  // **Limits tracing to specific domains (your app)**
  tracePropagationTargets: ['localhost', /^https:\/\/app\.cropmap\.doktar\.cc\//, /^https:\/\/app\.cropmap\.com\//],

  // **Enables session replay for better debugging (optional)**
  // replaysSessionSampleRate: 0.1, // Captures 10% of user sessions
  // replaysOnErrorSampleRate: 1.0, // Captures 100% of sessions with an error

  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  // profilesSampleRate: 1.0,

  ignoreErrors: [
    "Service Worker registration failed", 
    "The FetchEvent for", 
    "The FetchEvent", 
    "navigator.serviceWorker"
  ],
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
